import { postJSON, Post } from "../utils/http.js"

export function getNotification(params) {
  return postJSON("/api/pigeon/blacklist", params, { loading: true })
}

export function setNotification(params) {
  return postJSON("/api/pigeon/blacklist/update", params, { loading: true })
}

export async function closeAPPAndSMSNotification(phoneNum) {
  const params = {
    edit: 2,
    phoneNum
  }

  const NEED_OPEN_TYPE = [2, 5]
  const primises = NEED_OPEN_TYPE.map(type => {
    return setNotification({ param: { ...params, blacklistType: type } })
  })
  await Promise.all(primises)
}

export function getUserNotificationHasUnread(params) {
  return Post("/api/notify-center/hasUnread", params)
}

export function getUserNotificationCategoryList(params) {
  return Post("/api/notify-center/categoryList", params, { loading: true })
}

export function getUserNotificationMsgList(params, loading = false) {
  return Post("/api/notify-center/msgList", params, { loading })
}

export function getUserNotificatioMsgDetail(params) {
  return Post("/api/notify-center/msgDetail", params, { loading: true })
}

export function markNotificationAsRead(params) {
  return Post("/api/notify-center/markAsRead", params, { loading: true })
}

export function clearNotificationUnread(params) {
  return Post("/api/notify-center/clearUnread", params, { loading: true })
}
